import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "bootstrap-data-table card datatable-card",
  "data-tour": "datatable"
}
const _hoisted_2 = {
  key: 0,
  class: "card-header datatable-card-header d-flex flex-wrap justify-content-between align-items-center gap-2"
}
const _hoisted_3 = { class: "datatable-action-zone d-flex flex-wrap align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "btn-group btn-group-sm datatable-actions",
  "data-tour": "datatable-actions",
  role: "group",
  "aria-label": "Actions du tableau"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "datatable-header-controls d-flex flex-wrap align-items-center justify-content-end gap-2" }
const _hoisted_9 = {
  key: 0,
  class: "datatable-search",
  "data-tour": "datatable-search"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "card-body p-0" }
const _hoisted_12 = {
  key: 0,
  class: "datatable-selection-toolbar d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2",
  "data-test": "datatable-selection-toolbar"
}
const _hoisted_13 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_14 = {
  class: "datatable-selection-count",
  role: "status"
}
const _hoisted_15 = {
  key: 0,
  class: "text-danger small fw-semibold",
  "data-test": "datatable-selection-limit-warning",
  role: "alert"
}
const _hoisted_16 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "datatable-active-state px-3 py-2",
  "data-test": "datatable-active-state-badge",
  role: "status"
}
const _hoisted_20 = { class: "datatable-active-state-badge" }
const _hoisted_21 = {
  key: 2,
  class: "text-center py-4"
}
const _hoisted_22 = { key: 3 }
const _hoisted_23 = {
  class: "table-responsive datatable-responsive",
  "data-tour": "datatable-body"
}
const _hoisted_24 = { class: "table table-striped table-hover align-middle mb-0 datatable-table" }
const _hoisted_25 = { class: "table-light" }
const _hoisted_26 = {
  key: 0,
  scope: "col",
  class: "datatable-selection-column d-print-none"
}
const _hoisted_27 = ["checked", "indeterminate", "disabled", "aria-checked", "aria-label"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "datatable-header-label d-inline-flex align-items-center gap-1 text-nowrap" }
const _hoisted_30 = ["aria-selected", "onClick", "onKeyup"]
const _hoisted_31 = ["checked", "disabled", "aria-label", "onChange"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["colspan"]
const _hoisted_34 = {
  key: 1,
  class: "card-footer datatable-footer d-flex flex-wrap justify-content-between align-items-center gap-2"
}
const _hoisted_35 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  key: 0,
  class: "btn-group btn-group-sm datatable-pagination",
  role: "group",
  "aria-label": "Pagination",
  "data-tour": "datatable-pagination"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["aria-current", "disabled", "onClick"]
const _hoisted_41 = {
  key: 1,
  type: "button",
  class: "btn btn-outline-secondary datatable-pagination-ellipsis",
  disabled: "",
  "aria-hidden": "true"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["id"]
const _hoisted_44 = ["data-column-key"]
const _hoisted_45 = ["aria-label", "aria-describedby", "onPointerdown", "onKeydown"]
const _hoisted_46 = ["for"]
const _hoisted_47 = {
  class: "visually-hidden",
  "aria-live": "polite"
}
const _hoisted_48 = {
  key: 0,
  class: "alert alert-warning py-2 mt-3 mb-0"
}
const _hoisted_49 = { class: "d-flex flex-wrap justify-content-between gap-2 w-100" }
const _hoisted_50 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_51 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_52 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueInputText = _resolveComponent("PrimevueInputText")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_PrimevueDialog = _resolveComponent("PrimevueDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.showRefresh || _ctx.showExport || _ctx.showPrint)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.showRefresh)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-outline-secondary",
                        disabled: _ctx.loading,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshTable && _ctx.refreshTable(...args)))
                      }, [...(_cache[31] || (_cache[31] = [
                        _createElementVNode("i", { class: "fa fa-rotate-right" }, null, -1),
                        _createElementVNode("span", null, "Actualiser", -1)
                      ]))], 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (_ctx.showExport)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-outline-success",
                        disabled: _ctx.loading || !_ctx.items.length,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportVisibleRows && _ctx.exportVisibleRows(...args)))
                      }, [...(_cache[32] || (_cache[32] = [
                        _createElementVNode("i", { class: "fa fa-file-excel" }, null, -1),
                        _createElementVNode("span", null, "Excel", -1)
                      ]))], 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_ctx.showPrint)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-outline-primary",
                        disabled: _ctx.loading || !_ctx.items.length,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.printVisibleRows && _ctx.printVisibleRows(...args)))
                      }, [...(_cache[33] || (_cache[33] = [
                        _createElementVNode("i", { class: "fa fa-print" }, null, -1),
                        _createElementVNode("span", null, "Imprimer", -1)
                      ]))], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm btn-icon-label datatable-columns-button",
              title: "Choisir les colonnes affichées",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openColumnsDialog && _ctx.openColumnsDialog(...args)))
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("i", {
                class: "fa fa-table-columns",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-label" }, "Colonnes", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.searchable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fa fa-search datatable-search-icon" }, null, -1)),
                  _createVNode(_component_PrimevueInputText, {
                    modelValue: _ctx.localSearchValue,
                    type: "text",
                    class: "w-100 datatable-search-input",
                    placeholder: _ctx.searchPlaceholder,
                    "onUpdate:modelValue": _ctx.handleSearchInput,
                    onKeyup: _withKeys(_ctx.submitSearch, ["enter"])
                  }, null, 8, ["modelValue", "placeholder", "onUpdate:modelValue", "onKeyup"]),
                  (_ctx.localSearchValue)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "datatable-search-clear",
                        disabled: _ctx.loading,
                        title: "Effacer la recherche",
                        "aria-label": "Effacer la recherche",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                      }, [...(_cache[35] || (_cache[35] = [
                        _createElementVNode("i", { class: "fa fa-xmark" }, null, -1)
                      ]))], 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "header-extra", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.selectionEnabled && _ctx.selectedCount > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.selectedCount) + " " + _toDisplayString(_ctx.selectedCount > 1 ? 'lignes sélectionnées' : 'ligne sélectionnée'), 1),
              (_ctx.isSelectionOverLimit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, " La limite de " + _toDisplayString(_ctx.normalizedBulkActionLimit) + " lignes par action est dépassée. ", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("fieldset", {
                class: "datatable-bulk-actions d-flex flex-wrap align-items-center gap-2 m-0 p-0 border-0",
                disabled: _ctx.selectionDisabled || _ctx.isSelectionOverLimit
              }, [
                _renderSlot(_ctx.$slots, "bulk-actions", {
                  selectedIds: _ctx.normalizedSelectedRowIds,
                  selectedCount: _ctx.selectedCount,
                  isOverLimit: _ctx.isSelectionOverLimit,
                  clearSelection: _ctx.clearSelection
                }, undefined, true)
              ], 8, _hoisted_17),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-sm",
                "data-test": "datatable-clear-selection",
                disabled: _ctx.selectionDisabled,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)))
              }, [...(_cache[37] || (_cache[37] = [
                _createElementVNode("i", {
                  class: "fa fa-xmark me-1",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode(" Effacer la sélection ", -1)
              ]))], 8, _hoisted_18)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasActiveStateBadge)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, [
              _cache[38] || (_cache[38] = _createElementVNode("i", { class: "fa fa-filter" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.activeStateBadgeText), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[39] || (_cache[39] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin me-1" }, null, -1),
            _createTextVNode(" Chargement... ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("table", _hoisted_24, [
                _createElementVNode("thead", _hoisted_25, [
                  _createElementVNode("tr", null, [
                    (_ctx.selectionEnabled)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_26, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input m-0",
                            "data-test": "datatable-select-visible",
                            checked: _ctx.allVisibleRowsSelected,
                            indeterminate: _ctx.someVisibleRowsSelected,
                            disabled: _ctx.selectionDisabled || _ctx.visibleSelectableIds.length === 0,
                            "aria-checked": _ctx.someVisibleRowsSelected ? 'mixed' : String(_ctx.allVisibleRowsSelected),
                            "aria-label": _ctx.allVisibleRowsSelected ? 'Désélectionner les lignes de la page' : 'Sélectionner les lignes de la page',
                            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                            onKeydown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                            onKeyup: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                            onChange: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleVisibleSelectionChange && _ctx.handleVisibleSelectionChange(...args)), ["stop"]))
                          }, null, 40, _hoisted_27)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (column) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: column.key,
                        scope: "col",
                        class: _normalizeClass(['datatable-header-cell', 'text-nowrap', column.headerClass, { 'datatable-sortable': column.sortable }]),
                        style: _normalizeStyle(column.style || null),
                        onClick: ($event: any) => (column.sortable && _ctx.changeSort(column))
                      }, [
                        _createElementVNode("span", _hoisted_29, [
                          _createTextVNode(_toDisplayString(column.label) + " ", 1),
                          (column.sortable)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(["fa", _ctx.sortIcon(column.key)])
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ])
                      ], 14, _hoisted_28))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row[_ctx.rowKey],
                      class: _normalizeClass(["datatable-row", { 'datatable-row-selected': _ctx.selectionEnabled && _ctx.isRowSelected(row) }]),
                      "aria-selected": _ctx.selectionEnabled ? _ctx.isRowSelected(row) : undefined,
                      tabindex: "0",
                      onClick: ($event: any) => (_ctx.openRow(row)),
                      onKeyup: _withKeys(($event: any) => (_ctx.openRow(row)), ["enter"])
                    }, [
                      (_ctx.selectionEnabled)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            class: "datatable-selection-column d-print-none",
                            onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
                            onKeydown: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                            onKeyup: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input m-0",
                              "data-test": "datatable-row-selection",
                              checked: _ctx.isRowSelected(row),
                              disabled: _ctx.selectionDisabled || !_ctx.canSelectRow(row),
                              "aria-label": _ctx.rowSelectionLabel(row),
                              onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                              onKeydown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                              onKeyup: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                              onChange: _withModifiers(($event: any) => (_ctx.handleRowSelectionChange(row, $event)), ["stop"])
                            }, null, 40, _hoisted_31)
                          ], 32))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (column) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: `${row[_ctx.rowKey]}-${column.key}`,
                          class: _normalizeClass(column.class)
                        }, [
                          _renderSlot(_ctx.$slots, `cell-${column.key}`, {
                            row: row,
                            value: _ctx.valueFor(row, column.key)
                          }, () => [
                            _createTextVNode(_toDisplayString(_ctx.displayValue(_ctx.valueFor(row, column.key))), 1)
                          ], true)
                        ], 2))
                      }), 128))
                    ], 42, _hoisted_30))
                  }), 128)),
                  (!_ctx.items.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                        _createElementVNode("td", {
                          colspan: _ctx.visibleColumns.length + (_ctx.selectionEnabled ? 1 : 0),
                          class: "text-center text-muted py-4"
                        }, _toDisplayString(_ctx.emptyText), 9, _hoisted_33)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
    ]),
    (!_ctx.loading && _ctx.showFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("small", _hoisted_36, _toDisplayString(_ctx.footerRangeText), 1),
            (_ctx.canChangePerPage)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.localPerPage) = $event)),
                  class: "form-select form-select-sm datatable-per-page",
                  "data-tour": "datatable-per-page",
                  "aria-label": "Nombre de lignes à charger",
                  onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.changeRowsPerPage && _ctx.changeRowsPerPage(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.perPageChoices, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option,
                      value: option
                    }, _toDisplayString(option), 9, _hoisted_37))
                  }), 128))
                ], 544)), [
                  [
                    _vModelSelect,
                    _ctx.localPerPage,
                    void 0,
                    { number: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          (_ctx.pagination)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary datatable-page-button",
                  disabled: _ctx.pagination.current_page <= 1,
                  "aria-label": "Page précédente",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.changePage(_ctx.pagination.current_page - 1)))
                }, [...(_cache[40] || (_cache[40] = [
                  _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
                ]))], 8, _hoisted_39),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationItems, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.key
                  }, [
                    (item.type === 'page')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: _normalizeClass(["btn datatable-page-button", item.active ? 'btn-primary active' : 'btn-outline-secondary']),
                          "aria-current": item.active ? 'page' : undefined,
                          disabled: item.active,
                          onClick: ($event: any) => (_ctx.changePage(item.page))
                        }, _toDisplayString(item.page), 11, _hoisted_40))
                      : (_openBlock(), _createElementBlock("button", _hoisted_41, " … "))
                  ], 64))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary datatable-page-button",
                  disabled: _ctx.pagination.current_page >= _ctx.pagination.last_page,
                  "aria-label": "Page suivante",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changePage(_ctx.pagination.current_page + 1)))
                }, [...(_cache[41] || (_cache[41] = [
                  _createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
                ]))], 8, _hoisted_42)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PrimevueDialog, {
      visible: _ctx.columnsDialogVisible,
      "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.columnsDialogVisible) = $event)),
      modal: "",
      header: "Colonnes affichées",
      style: { width: '460px', maxWidth: 'calc(100vw - 2rem)' }
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm btn-icon-label",
              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.selectAllColumns && _ctx.selectAllColumns(...args)))
            }, [...(_cache[43] || (_cache[43] = [
              _createElementVNode("i", {
                class: "fa fa-check-double",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-label" }, "Tout afficher", -1)
            ]))]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm btn-icon-label",
              onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.resetColumnSelection && _ctx.resetColumnSelection(...args)))
            }, [...(_cache[44] || (_cache[44] = [
              _createElementVNode("i", {
                class: "fa fa-rotate-left",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-label" }, "Réinitialiser", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm btn-icon-label",
              onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.closeColumnsDialog && _ctx.closeColumnsDialog(...args)))
            }, [...(_cache[45] || (_cache[45] = [
              _createElementVNode("i", {
                class: "fa fa-xmark",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-label" }, "Annuler", -1)
            ]))]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm btn-icon-label",
              disabled: !_ctx.draftVisibleColumnKeys.length,
              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.applyColumnSelection && _ctx.applyColumnSelection(...args)))
            }, [...(_cache[46] || (_cache[46] = [
              _createElementVNode("i", {
                class: "fa fa-check",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-label" }, "Appliquer", -1)
            ]))], 8, _hoisted_52)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _cache[47] || (_cache[47] = _createElementVNode("p", { class: "text-muted small mb-3" }, " Sélectionnez les colonnes à afficher et définissez leur ordre dans le tableau, les exports et l’impression. ", -1)),
        _createElementVNode("p", {
          class: "text-muted small",
          id: _ctx.columnCheckboxId('drag-help')
        }, "Glissez la poignée pour déplacer une colonne, ou utilisez les flèches du clavier.", 8, _hoisted_43),
        _createElementVNode("div", {
          ref: "columnOptions",
          class: "datatable-column-options",
          onPointermove: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.moveColumnDrag && _ctx.moveColumnDrag(...args))),
          onPointerup: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.finishColumnDrag && _ctx.finishColumnDrag(...args))),
          onPointercancel: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.cancelColumnDrag && _ctx.cancelColumnDrag(...args))),
          onLostpointercapture: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.finishColumnDrag && _ctx.finishColumnDrag(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draftOrderedColumns, (column) => {
            return (_openBlock(), _createElementBlock("div", {
              key: column.key,
              class: _normalizeClass(["datatable-column-option", { 'is-dragging': _ctx.draggedColumnKey === column.key && _ctx.columnDragMoved }]),
              "data-column-key": column.key
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "datatable-column-handle",
                "aria-label": `Déplacer ${column.label}`,
                "aria-describedby": _ctx.columnCheckboxId('drag-help'),
                onPointerdown: ($event: any) => (_ctx.startColumnDrag($event, column.key)),
                onKeydown: ($event: any) => (_ctx.onColumnOrderKeydown($event, column.key)),
                onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["prevent","stop"]))
              }, [...(_cache[42] || (_cache[42] = [
                _createElementVNode("i", {
                  class: "fa fa-grip-vertical",
                  "aria-hidden": "true"
                }, null, -1)
              ]))], 40, _hoisted_45),
              _createVNode(_component_PrimevueCheckbox, {
                modelValue: _ctx.draftVisibleColumnKeys,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.draftVisibleColumnKeys) = $event)),
                inputId: _ctx.columnCheckboxId(column.key),
                value: column.key
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                class: "flex-grow-1 mb-0",
                for: _ctx.columnCheckboxId(column.key)
              }, _toDisplayString(column.label), 9, _hoisted_46)
            ], 10, _hoisted_44))
          }), 128))
        ], 544),
        _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.columnOrderAnnouncement), 1),
        (!_ctx.draftVisibleColumnKeys.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Au moins une colonne doit rester affichée. "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}